export type TextareaType = {
    value: string
}

export const textAreaInitalState: TextareaType = {
    value: ""
}